import axios from "../helper/Axios.js";
import { absentUrl, adminUrl } from "../config/config.js";

const serialize = function (obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};


export async function getAdmins({ searchQuery, limit, page, sortBy, isActive, excludeMe }) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/admins?searchQuery=${searchQuery || ""}&limit=${limit ||
        ""}&page=${page || ""}&sortBy=${sortBy || ""}&isActive=${isActive || ""}&excludeMe=${excludeMe || ""}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getAdminsByUserName({ username }) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/admins/byusername?username=${username || ""}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function selectAdmin({ searchquery, isActive, disableregion }) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/admins/selectadmin?searchquery=${searchquery || ""}&isActive=${isActive || ""}&disableregion=${disableregion || false}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getAdminsSelect({ searchQuery, limit, page, sortBy }) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/admins?searchQuery=${searchQuery || ""}&limit=${limit ||
        ""}&page=${page || ""}&sortBy=${sortBy || ""}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getAdminsSales({ searchQuery, limit, page, sortBy }) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/admins?searchQuery=${searchQuery || ""}&role=marketing&limit=${limit ||
        ""}&page=${page || ""}&sortBy=${sortBy || ""}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getAdminsDetail(adminId) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/admins/${adminId}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function createAdmin({
  name,
  username,
  phoneNumber,
  password,
  role,
  isActive,
  allowUpdateChat,
  region,
  limitedIP
}) {
  try {
    let response = await axios.Post({
      url: `${adminUrl}/admins`,
      data: { name, username, phoneNumber, password, role, isActive, allowUpdateChat, region, limitedIP }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function toggleAdminStatus(adminId) {
  try {
    let response = await axios.Patch({
      url: `${adminUrl}/admins/${adminId}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function updateAdmin({ adminId, name, username, phoneNumber, password, confirmPassword, role, isActive, allowUpdateChat, region, limitedIP, allowedPlatformLogin }) {
  try {
    let response = await axios.Put({
      url: `${adminUrl}/admins/id/${adminId}`,
      data: { name, username, phoneNumber, password, confirmPassword, role, isActive, allowUpdateChat, region, limitedIP, allowedPlatformLogin }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function updateAdminLeave({
  timezone,
  checkIn,
  checkOut,
  dayOff,
  totalSickLeave,
  totalAnnualLeave,
  totalUnpaidLeave
}) {
  try {
    let response = await axios.Post({
      url: `${adminUrl}/admins/updateLeave`,
      data: {
        timezone,
        checkin: checkIn,
        chekout: checkOut,
        dayoff: dayOff,
        sickleave: totalSickLeave,
        annualleave: totalAnnualLeave,
        unpaidleave: totalUnpaidLeave,
      }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getAdminLeave({ adminId }) {
  try {
    let response = await axios.Get({
      url: `${absentUrl}/absent/leavelistnofilter`,
      params: {
        adminId
      }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getAdminLeaveTotalYear({ adminId }) {
  try {
    let response = await axios.Get({
      url: `${absentUrl}/absent/totalleaveyear`,
      params: {
        adminId
      }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}
export async function getAdminLeaveSickMonthly({ adminId }) {
  try {
    let response = await axios.Get({
      url: `${absentUrl}/absent/totalsickleavemonth`,
      params: {
        adminId
      }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}
export async function getAdminLeaveSickYearly({ adminId }) {
  try {
    let response = await axios.Get({
      url: `${absentUrl}/absent/totalsickleaveyear`,
      params: {
        adminId
      }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}
export async function getAdminLeaveUnpaidTotalMonth({ adminId }) {
  try {
    let response = await axios.Get({
      url: `${absentUrl}/absent/totalunpaidleavemonth`,
      params: {
        adminId
      }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}
export async function getAdminLeaveUnpaidTotalYear({ adminId }) {
  try {
    let response = await axios.Get({
      url: `${absentUrl}/absent/totalunpaidleaveyear`,
      params: {
        adminId
      }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}
export async function getAdminLeaveMinuteLate({ adminId }) {
  try {
    let response = await axios.Get({
      url: `${absentUrl}/absent/countminuteslate`,
      params: {
        adminId
      }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function getPermissions(role, adminId) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/adminsrole/permission?role=${role || ""}&adminId=${adminId}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function addPermisssions({ role, menu, childmenu }) {
  try {
    let response = await axios.Post({
      url: `${adminUrl}/adminsrole/addpermission`,
      data: { role, menu, childmenu }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function removePermissions({ role, childmenu }) {
  try {
    let response = await axios.Post({
      url: `${adminUrl}/adminsrole/removeuserpermission`,
      data: { role, childmenu }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }

}
export async function forceLogOut(token) {
  try {
    let response = await axios.Post({
      url: `${adminUrl}/admins/deletetoken`,
      data: { token }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}
export async function getAdminIMEI(id = '') {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/getimei?adminId=${id}`
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}
//cek sini 1
export async function addIMEIGroupinit({userId,adminId,name, owner, phonetype }) {
  try {
    let response = await axios.Post({
      url: `${adminUrl}/addnewimeigroup`,
      data: {userId,adminId,user: name,owner,phonetype }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function addAdminIMEI({ imei, type, userId, adminId, name, owner, phonetype,groupId }) {
  try {
    let response = await axios.Post({
      url: `${adminUrl}/addnewimei`,
      data: { imei, type, userId, adminId, user: name, owner, phonetype ,groupId}
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function  updateIMEIGroup( _id, androidid, imei1, imei2, userId,adminId,name, owner, phonetype) {
  try{
    let response = await axios.Post({
      url: `${adminUrl}/updateexistingimeigroup`,
      data: { _id, androidid, imei1, imei2,userId, adminId, user: name, owner, phonetype }
    });

    console.log(response.data)
    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  }catch (e) {
    return { error: e.response.data };
}}

export async function updateAdminIMEI({ _id, imei, type, userId, adminId, name, owner, phonetype,groupId }) {
  try {
    let response = await axios.Post({
      url: `${adminUrl}/updateexistingimei`,
      data: { _id, imei, type, userId, adminId, user: name, owner, phonetype,groupId }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}
export async function deleteAdminIMEI({
  imeiid, imeis , adminId
}) {
  try {
    let response = await axios.Get({
      url: `${adminUrl}/deleteimei?imeiid=${(imeiid)? imeiid : ''}&imeis=${(imeis)? imeis : ''}&adminId=${(adminId)? adminId : ''}`,
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }
    return { data: "response.data" };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function changePassword({
  id, oldpass, password
}) {
  try {
    let response = await axios.Post({
      url: `${adminUrl}/admins/password`,
      data: { id, oldpass, password }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data };
  } catch (e) {
    return { error: e.response.data };
  }
}

export async function connectFirebase({
  fcm
}) {
  try {
    let response = await axios.Post({
      url: `${adminUrl}/admins/firebase-connect`,
      data: { fcm }
    });

    if (response.statusCode !== 200) {
      return { error: response.message };
    }

    return { data: response.data }
  } catch (e) {
    return { error: e.response.data }
  }
}
// Get All Imei Exception
// FUNGSI INI MEMANGGIL API DARI BACKEND UNTUK MENDAPATKAN SEMUA DATA IMEI EXCEPTION.
export async function getAllImeiException(params) {
  try {
    const newQuery = (({
      limit,
      page,
      imeiInput,
      phoneStatus,
      phoneType,
      value,
      getAllList,
      select,
      adminName,
      ...params
    }) => {
      adminName = adminName? adminName.map((v)=>{return v.value}) : []
      const neqry = {};
      Object.assign(neqry, { limit: limit ? limit : 20 });
      Object.assign(neqry, { page: page ? page : 0 });
      if (imeiInput) { Object.assign(neqry, { imei: imeiInput ? imeiInput : "" }) };
      if (phoneStatus) { Object.assign(neqry, { owner: phoneStatus ? phoneStatus.value : "" }) };
      if (phoneType) { Object.assign(neqry, { phonetype: phoneType ? phoneType : "" }) };
      if (value) { Object.assign(neqry, { user: value ? value : "" }) };
      if (getAllList) { Object.assign(neqry, { getAllList: getAllList === "true" ? "true" : "false" }) };
      if (select) { Object.assign(neqry, { select: select ? select : "" }) };
      if (adminName) { Object.assign(neqry, { adminId: adminName ? adminName : "" }) };
      return serialize(neqry);
    })(params);
    let response = await axios.Get({
      url: `${adminUrl}/imei/exceptionlist?${newQuery}`,
    });

    if (response.statusCode !== 200) {
      return { error: response.message }
    }
    return { data: response.data }
  } catch (e) {
    console.log('disini error', e)
    return { error: e };
  }
};

export async function imeiUpdateOwner({
  _id,
  user,
  adminId
}) {
  try {
    let response = await axios.Post({
      url: `${adminUrl}/imei/update-owner`,
      data: { _id, user, adminId }
    });
    return { data: response.data };
  } catch (e) {
    return { error: e };
  };
};

export async function getImeiDetails({
  adminId,
  phoneType
}){
  try {
    let response = await axios.Get({
      url: `${adminUrl}/imei/get-detail/${adminId}/${phoneType}`,
    });
    return { data: response.data };
  } catch (e) {
    return { error: e };
  };

}

export async function changeImeiGroups({
  _id,
  groupId,
  adminId,
  user
}){
  try {
    let response = await axios.Get({
      url: `${adminUrl}/imei/change-group?imeiid=${(_id)? _id : ''}&groupId=${(groupId)? groupId : ''}&adminId=${(adminId)? adminId : ''}&user=${(user)? user : ''}`,
    });
    return { data: response.data };
  } catch (e) {
    return { error: e };
  };

}

